export default __webpack_public_path__ + "static/media/grandmaAndLady5M.1273d134.jpg";